
var cientifico = [
	"Ciencia",			
	"Datos",			
	"Teorías",			
	"Investigación",	
	"Doctorado",		
	"Experimentos",		
	"Hipótesis"			
	]	

var aburrido = [
	"Monótono",
	"Pesado",
	"Rutina",
	"Bostezo",
	"Soso",
	"Tedioso",
	"Pereza"
	]

var divertido = [
	"Diversión",
	"Entretenido",
	"Ocio",
	"Placer",
	"Disfrutar",
	"Satisfacción",
	"Humor"
	]

export function getPart(num,total){
	let output = {
        current: num,
        total: total        
      }
	switch(num){
		//Standard Part 1
		case 1:
			output.base = cientifico.concat(aburrido).concat(divertido)
			output.serie = shuffle(output.base.length,24)
			console.log("Part 1. Serie: ",output.serie)
			output.options = [{
					            keyboard: "E",
					            value: ["Científico","Aburrido"],
					            valid: [1,2,3,4,5,6,7,8,9,10,11,12,13,14]
					          },
					          {
					            keyboard: "I",
					            value: ["","Divertido"],
					            valid: [15,16,17,18,19,20,21]
					          }]
		break
		//Standard Part 2
		case 2:
			output.base = cientifico.concat(aburrido).concat(divertido)
			output.serie = shuffle(output.base.length,72)
			console.log("Part 2. Serie: ",output.serie)
			output.options = [{
					            keyboard: "E",
					            value: ["Científico","Aburrido"],
					            valid: [1,2,3,4,5,6,7,8,9,10,11,12,13,14]
					          },
					          {
					            keyboard: "I",
					            value: ["","Divertido"],
					            valid: [15,16,17,18,19,20,21]
					          }]
		break
		//Standard Part 3
		case 3:
			output.base = cientifico.concat(divertido).concat(aburrido)
			output.serie = shuffle(output.base.length,24)
			console.log("Part 3. Serie: ",output.serie)
			output.options = [{
					            keyboard: "E",
					            value: ["Científico","Divertido"],
					            valid: [1,2,3,4,5,6,7,8,9,10,11,12,13,14]
					          },
					          {
					            keyboard: "I",
					            value: ["","Aburrido"],
					            valid: [15,16,17,18,19,20,21]
					          }]
		break
		//Standard Part 4
		case 4:
			output.base = cientifico.concat(divertido).concat(aburrido)
			output.serie = shuffle(output.base.length,72)
			console.log("Part 4. Serie: ",output.serie)
			output.options = [{
					            keyboard: "E",
					            value: ["Científico","Divertido"],
					            valid: [1,2,3,4,5,6,7,8,9,10,11,12,13,14]
					          },
					          {
					            keyboard: "I",
					            value: ["","Aburrido"],
					            valid: [15,16,17,18,19,20,21]
					          }]
		break
		//Standard Part 5
		// case 5:
		// 	output.base = enfermos.concat(sanos)
		// 	output.serie = [8,4,2,3,6,8,1,6,2,8,1,7,6,8,5,4,5,7,3,2,1,4,3,7]
		// 	output.options = [{
		// 			            keyboard: "E",
		// 			            value: ["","Enfermo"],
		// 			            valid: [1,2,3,4]
		// 			          },
		// 			          {
		// 			            keyboard: "I",
		// 			            value: ["","Sano"],
		// 			            valid: [5,6,7,8]
		// 			          }]
		// break
		//Standard Part 6
		// case 6:
		// 	output.base = enfermos.concat(sanos).concat(buenos).concat(malos)
		// 	output.serie = [6,16,3,4,1,15,13,6,11,8,22,3,11,2,7,12,5,22,5,21,14,17,23,21,4,14,9,19,18,23,2,6,8,24,2,12,7,8,13,3,5,19,20,16,9,2,7,4,5,3,15,6,18,1,17,7,10,24,4,8,20,10,1,1]
		// 	output.options = [{
		// 			            keyboard: "E",
		// 			            value: ["Malo","Enfermo"],
		// 			            valid: [1,2,3,4,17,18,19,20,21,22,23,24]
		// 			          },
		// 			          {
		// 			            keyboard: "I",
		// 			            value: ["Bueno","Sano"],
		// 			            valid: [5,6,7,8,9,10,11,12,13,14,15,16]
		// 			          }]
		// break
		//Standard Part 7
		// case 7:
		// 	output.base = enfermos.concat(sanos).concat(buenos).concat(malos)
		// 	output.serie = [1,12,16,17,6,7,8,23,20,2,8,7,5,16,7,1,3,21,5,24,11,23,17,22,9,2,3,4,13,5,19,4,15,3,12,9,14,4,13,6,10,20,5,15,11,6,18,7,2,3,10,18,21,1,19,8,14,2,4,6,22,1,24,21]
		// 	output.options = [{
		// 			            keyboard: "E",
		// 			            value: ["Malo","Enfermo"],
		// 			            valid: [1,2,3,4,17,18,19,20,21,22,23,24]
		// 			          },
		// 			          {
		// 			            keyboard: "I",
		// 			            value: ["Bueno","Sano"],
		// 			            valid: [5,6,7,8,9,10,11,12,13,14,15,16]
		// 			          }]
		// break
	}
	return output
}

function getRndInteger(min, max) {
	return Math.floor(Math.random() * (max - min + 1) ) + min;
}
// La forma de hacer shuffle es la siguiente, dado un indice maximo (tamaño del array) y un numero de ensayos (size)
// Se genera un array temporal con los indices entre 0 y max, y se van sacando indices hasta que este array queda vacio 
// En este punto se regenerá de nuevo con el array de referencia y se continua hasta llegar al numero de ensayo especificados

function shuffle(max,size){
	let refArray = []
	let outArray = []
	let tmpArray = []
	
	for (let i = 0; i < max; i++){
		refArray[i] = i + 1
	}
	
	tmpArray = refArray.concat([])
	
	for (let i = 0; i < size; i++){
		
		if(tmpArray.length == 0)
			tmpArray = refArray.concat([])
			
		let randomIndex = getRndInteger(0,tmpArray.length-1)

		let targetValue = tmpArray.splice(randomIndex,1)
		
		outArray.push(targetValue[0])
		// console.log("XX",randomIndex,targetValue,outArray)
	}
	// console.log(outArray)
	return outArray
}